import { useEffect, useState } from "react";

const defaultState = {
    angle: 0,
    type: "landscape-primary",
};

const useOrientation = (initialState = defaultState) => {
    const [state, setState] = useState(initialState);

    useEffect(() => {
        const ornt = screen.orientation;
        setState({
            angle: ornt?.angle ?? 0,
            type: ornt?.type ?? ""
        });
    }, [screen.orientation]);

    return state;
};

export default useOrientation;
